/**
 * Reusable empty state — shown when a list has no data.
 */
import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

interface Props {
  icon: ReactNode;
  title: string;
  description?: string;
}

export function EmptyState({ icon, title, description }: Props): React.JSX.Element {
  return (
    <div className={styles['empty']}>
      <span className="ns-icon-tile" aria-hidden="true">
        {icon}
      </span>
      <div className={styles['text']}>
        <p className={`ns-display ${styles['title']}`}>{title}</p>
        {description && <p className={styles['description']}>{description}</p>}
      </div>
    </div>
  );
}
